<template>
    <v-container max-width="100%" style="margin-top: 2%">
      <v-container class="toolbar__container">
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="idEmpresaSelected"
                :items="empresas"
                item-text="razao_social"
                item-value="id_empresa"
                clearable
                :label="$tc('company.self', 1)"
                @change="populaLinhasSelect"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-datetime-picker
                :label="$t('speedReport.startDate')"
                v-model="dti"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtiProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-datetime-picker
              :label="$t('speedReport.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              v-model="idLinhaSelected"
              :items="linhasSelect"
              item-text="nome_linha"
              item-value="id_linha"
              clearable
              :label="$t('guide.headers.line')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <MultiplaEscolha 
              :items="unidadesItens"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
          </v-row>
          <!-- <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="idVeiculosSelected"
              :items="veiculosSelect"
              item-text="numero_ordem"
              item-value="id_veiculo"
              clearable
              multiple
              label="Veículo"
            ></v-autocomplete>
          </v-col>
          </v-row> -->
        </v-form>
      </v-container>

      <v-dialog
        v-model="plotagemDialog"
        fullscreen
        max-width="100%"
        style="z-index: 80000; background-color: white"
        >
        <v-card>
            <v-toolbar dark color="primary">
            <v-btn icon dark @click="closePlotagem">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('convoyReport.convoy_map') }}</v-toolbar-title>
            </v-toolbar>
            <v-container style="margin-top: 20px;">
              <MapaPlotagem 
                :idVeiculo="idVeiculosComboio"
                :posicoes="posicoesComboio"
                :user="user"
                :token="token"
                :key="key"
              />
            </v-container>
          </v-card>
        </v-dialog>

      <merus-data-table
        :headers="headers"
        :items="comboios"
        sort-by="id_comboio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loadingComboios"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
    

 cod-tabela="RELCOMBOIO" append-actions actions-i18n-key="guide.headers.line" @update:headers="headers = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('convoyReport.report')"
                :token="token"
                :items="comboios"
                csv-title="relcomboio"
                :pdf-title="$t('convoyReport.convoys')"
                :pdf-headers="headers"
                pdf-filename="relcomboio"
                hide-search
            />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click="openPlotagem(item)"
            >mdi-map-marker</v-icon
          >
        </template>

    </merus-data-table>

      <v-card style="border-radius: 10px;">
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ $t('convoyReport.chart') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container style="justify-content: center; align-content: center; width: 100%;" v-if="loadingViagens">
            <v-progress-circular
              :size="100"
              :width="10"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-container>
          <v-container style="border: black solid 2px;" v-if="!!posicoes.length && !loadingViagens">
            <ChartComboio 
              :posicoes="posicoes"
              :viagens="viagens"
            />
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import ChartComboio from "./ChartComboio.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MapaPlotagem from "./MapaPlotagem.vue";
import DateUtils from "../utils/dateutils";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
    components: {
        ChartComboio,
        MerusDataTable,
        CadastroToolbar,
        MapaPlotagem,
        MultiplaEscolha,
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        config: null,
        loadingComboios: false,
        loadingViagens: false,
        recursos: [],
        linhasSelect: [],
        veiculos: [],
        viagens: [],
        posicoes: [],
        empresas: [],
        comboios: [],
        dti: null,
        dtf: null,
        idEmpresaSelected: null,
        idLinhaSelected: null,
        idVeiculosSelected: [],
        unidades: [],
        unidadesSelecionadas: [],

        timeProps: {
            useSeconds: true,
        },

        formValidado: false,
        plotagemDialog: false,
        idVeiculosComboio: [],
        dtInicioComboio: null,
        dtFinalComboio: null,
        posicoesComboio: [],
        key: 0,
    }),
    computed: {
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      today() {
        return new Date().toISOString().substring(0,10);
      },
      textFieldProps() {
        return {
          prependInnerIcon: "mdi-calendar",
          rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        };
      },
      dtiProps() {
        return {
          max: this.today
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      },
      unidadesItens() {
        return this.unidades;
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {

        initialize() {
          this.getConfig();
          this.populaRecursos();
          this.populaUnidades();
        },
        getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
          });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaEmpresas();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaEmpresas();
                    },
                });
                }
        },
        populaEmpresas() {
          this.empresas = this.recursos.map((r) => { if (r.id_empresa) return {id_empresa: r.id_empresa, razao_social: r.razao_social} });
        },
        /**
         * Linhas da empresa escolhida. Antes vinha do getalllinhas (todas as linhas +
         * sublinhas) so para filtrar por empresa em memoria; o select ja era inutil
         * enquanto nenhuma empresa estivesse selecionada.
         */
        populaLinhasSelect() {
            this.idLinhaSelected = null;
            if (!this.idEmpresaSelected) {
                this.linhasSelect = [];
                return;
            }
            apiController.request(apiController.endpoints.getLinhasporempresa, {
                params: { id: this.idEmpresaSelected },
                onSuccess: (response) => {
                    if (response.data && Array.isArray(response.data)) {
                        // getlinhasporempresa nao exclui sublinhas; o getalllinhas excluia.
                        this.linhasSelect = response.data.filter((l) => l.id_linha_principal == null);
                    } else {
                        EventBus.$emit('show-error', { error: response.data || { message: 'Erro ao carregar linhas' } });
                        this.linhasSelect = [];
                    }
                },
                onError: () => {
                    this.linhasSelect = [];
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaViagens() {
          this.loadingViagens = true;
          let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
          let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

          let temp = {
              id_linha: this.idLinhaSelected,
              dti: dataInicial,
              dtf: dataFinal
          };

          apiController.request(apiController.endpoints.getViagensrealizadaslinhadata, {
              data: temp,
              onSuccess: (response) => {
                  this.viagens = response.data;
                  if (this.viagens.length > 0) {
                    this.populaPosicoes();
                  } else {
                    this.loadingViagens = false;
                  }
              },
              onError: () => {
                  this.loadingViagens = false;
              },
          });
        },
        populaPosicoes() {
          let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
          let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

          apiController.request(apiController.endpoints.getPosicoesporlinhadata, {
            params: { id: this.idLinhaSelected, dti: dataInicial, dtf: dataFinal },
            onSuccess: (response) => {
              this.posicoes = response.data;
              this.loadingViagens = false;
            },
            onError: () => {
              this.loadingViagens = false;
            },
          });
        },
        populaComboios() {
          this.loadingComboios = true;
          let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
          let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
          this.comboios = [];

          apiController.request(apiController.endpoints.getVeiculoscomboiolinhadata, {
            params: { idlinha: this.idLinhaSelected, dti: dataInicial, dtf: dataFinal },
            onSuccess: (response) => {
              this.veiculos = response.data;
              let idcomboio = 0;
              if (this.veiculos.length > 0) {
                this.veiculos.forEach((v) => {
                  if (this.unidadesSelecionadas.length > 0) {
                    const selected = this.unidadesSelecionadas.map((id) => Number(id));
                    const rowUnidades = Array.isArray(v.unidades)
                      ? v.unidades.map((id) => Number(id))
                      : (v.id_unidade != null && Number(v.id_unidade) !== -1
                        ? [Number(v.id_unidade)]
                        : []);
                    const semUnidadeSelected = selected.includes(-1);
                    const linhaSemUnidade = rowUnidades.length === 0;
                    const matchesUnidade = selected.some(
                      (sid) => sid !== -1 && rowUnidades.includes(sid),
                    );
                    if (!matchesUnidade && !(semUnidadeSelected && linhaSemUnidade)) {
                      return;
                    }
                  }
                  
                  if (v.id_comboio !== idcomboio) {
                    this.comboios.push({
                      id_comboio: v.id_comboio,
                      dt_inicio_extenso: v.dt_inicio_extenso,
                      dt_fim_extenso: v.dt_fim_extenso,
                      dt_inicio: v.dt_inicio,
                      dt_fim: v.dt_fim,
                      linha: v.cod_linha,
                      sentido: v.descricao_sentido,
                      veiculos: [v.numero_ordem],
                      id_veiculos: [v.id_veiculo],
                      id_unidade: v.id_unidade
                    });
                    idcomboio = v.id_comboio;
                  } else {
                    let comboioExistente = this.comboios[this.comboios.findIndex((c) => c.id_comboio === v.id_comboio)]
                    comboioExistente.veiculos.push(v.numero_ordem);
                    comboioExistente.id_veiculos.push(v.id_veiculo);
                  }
                });
              }
              this.loadingComboios = false;
            },
            onError: () => {
              this.loadingComboios = false;
            },
          });
        },
        calculaDistancia(lat1, lat2, lon1, lon2) {
          if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
          } else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) { dist = 1; }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            return dist * 1000;
          }
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (this.formValidado) {
              this.populaViagens();
              this.populaComboios();
            }
        },
        setDefaultDateFilters() {
          let today = new Date();
          this.dti = today.toLocaleString().substring(0, 10) + " 00:00:00";
          this.dtf = today.toLocaleString().substring(0, 10) + " 23:59:59";
        },
        openPlotagem(comboio) {
          this.idVeiculosComboio = comboio.id_veiculos;
          this.posicoesComboio = this.posicoes.filter((p) => {
            return p.dt_posicao >= comboio.dt_inicio && p.dt_posicao <= comboio.dt_fim && comboio.id_veiculos.includes(p.id_carro);
          });
          this.key = this.key === 0 ? 1 : 0;
          this.plotagemDialog = true;
        },
        closePlotagem() {
          this.plotagemDialog = false;
          this.idVeiculosComboio = [];
          this.posicoesComboio = [];
        },
    }
}
</script>
<style>
    
</style>